import type { RouteDefinition } from "../route-definition.ts";

export const adminWorkspaceRoutes = {
  browseAll: {
    path: "/browseall",
    scope: "static",
    bucket: "admin",
    entry: "compatibility",
    disposition: "resolver",
  },
  admin: {
    path: "/admin",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.flags": {
    path: "/admin/system/flags",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.sql": {
    path: "/admin/system/sql",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.smartPlugs": {
    path: "/admin/system/smart-plugs",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.office": {
    path: "/admin/office",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
